import ApiService from "@/core/services/api.service";
import JwtService from "@/core/services/jwt.service";

const state = {};

const getters = {};

const mutations = {};

const actions = {
    getLocaisStatusBox(context, filtros) {
        filtros.componente = "SearchBoxLocaisStatus";
        return new Promise((resolve) => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("locaisStatus/access/listaBox", filtros).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    },
};

export default {
    state,
    actions,
    mutations,
    getters
};